import { render, staticRenderFns } from "./BodyPartWeightLifted.vue?vue&type=template&id=e6ea03e6&"
import script from "./BodyPartWeightLifted.vue?vue&type=script&lang=js&"
export * from "./BodyPartWeightLifted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports